import useSWR from 'swr'

import {
  recipeFetcher as menuExperienceRecipeFetcher,
  type MenuURN,
  type RecipeQueryResponse,
  type RecipeURN,
} from '@library/api-menu-experience'
import type { RecipeUUID } from '@library/menu-service'

type UseRecipeDetailDataInput = {
  menuId: string
  menuUrn?: MenuURN
  recipeUuid: RecipeUUID | null
  recipeUrn?: RecipeURN
  numPortions: number
  deliveryDate: string
  shouldFetchOptions?: boolean
  collectionId?: string
}

type UseRecipeDetailDataResult = {
  error: boolean
  loading: boolean
  recipe: RecipeQueryResponse | null
  reload: () => void
}

export const useRecipeDetailData = ({
  menuId,
  menuUrn,
  recipeUuid,
  recipeUrn,
  numPortions,
  deliveryDate,
  shouldFetchOptions = true,
  collectionId,
}: UseRecipeDetailDataInput): UseRecipeDetailDataResult => {
  const { data, mutate, isValidating, error } = useSWR(
    () =>
      recipeUuid && shouldFetchOptions
        ? {
            menuId,
            menuUrn,
            recipeId: recipeUuid,
            recipeUrn,
            numPortions,
            deliveryDate,
            collectionId,
          }
        : null,
    menuExperienceRecipeFetcher,
  )

  const reload = () => {
    mutate()
  }

  return {
    error: !!error,
    loading: !data && isValidating,
    recipe: data || null,
    reload,
  }
}
